import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { isSingleSelectServerUserGuest } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityActionHelpers';

import { AppState } from '../../../app/state/AppState';
import { Messages } from '../../../codegen/Localize';
import { serverUserDelete } from '../actions/ServerUserMenuActions';
import { IServerUserInfo } from '../models/IServerUserInfo';

export const ServerUserDeleteUsersAction: IEntityAction<IServerUserInfo, {}> = {
  name: EntityActionNames.ServerUserDeleteUsers,
  translateName: Messages.delete_action,
  isVisible: (_targetItems: IServerUserInfo[], _state: AppState) => {
    return true;
  },
  isClickable: (_availableActions: {}, targetItems: IServerUserInfo[], _state: AppState) => {
    return targetItems.length > 0 && !isSingleSelectServerUserGuest(targetItems);
  },
  createReduxAction: (targetItems: IServerUserInfo[]) => serverUserDelete(targetItems)
};
